Vendd.Scripts.load(function () {
    'use strict';

    var $form = $(".js-email-giftcard-form ");
    if ($form.length < 1)
        return;

    var $success = $('.js-success', $form), $error = $('.js-error', $form), $submitButton, $formWrapper;
    var form, rf, valOpts, hasData;

    form = $form.get(0);
    $submitButton = $('.js-submit-button', $form);
    $formWrapper = $('.form-wrapper', $form);

    form.formData = {
        fromName: $('input[name="fromName"]', $form).val(),
        toName: $('input[name="toName"]', $form).val(),
        email: $('input[name="email"]', $form).val(),
        emailconfirm: $('input[name="emailconfirm"]', $form).val(),
        customText: $('textarea[name="customText"]', $form).val()
    };

    
    //Disable the paste from the confirmation email field

    $('input[name="emailconfirm"]', $form).bind("cut copy paste",function(e) {
        e.preventDefault();
    });

    $form.on('keyup', 'input[name],textarea[name]', function (e) {
        var $this = $(this);
        var fieldName = $this.attr('name');

        form.formData[fieldName] = $this.val();
        rf = $form.data('validationEngine');
        rf.validate(fieldName);
    });

    $form.on('click', '.giftcard-item', function (e) {
        e.stopPropagation();
        var $this = $(this);

        $this.siblings('.active').removeClass('active');
        $this.addClass('active');
    });

    $form.on('click', '.js-submit-button', function (e) {
        $form.validationEngine(valOpts);
        rf = $form.data('validationEngine');

        e.preventDefault();
        e.stopPropagation();

        if (rf.validate()) {
            if (LhApp.Context.IsConsentsEnabled) {
                form.checkConsents();
            } else {
                form.submit();
            }
        }
    });

    form.submit = function () {
        form.loading(true);

        var $selectedGiftcard = $('.giftcard-list input:checked', $form),
            id = $selectedGiftcard.data('id'),
            skuId = $selectedGiftcard.data('skuid'),
            path = $selectedGiftcard.data('path'),
            qty = 1, extraAttributes = [], bundleItems = [], recipeItems = [], comboItems = [],
            itemInfo = {
                minQuantity: null,
                maxQuantity: null,
                quanta: null
            },
            enhancedInfo = {
                giftCardsInfo: [{
                    FromName: form.formData.fromName,
                    Email: form.formData.email,
                    ToName: form.formData.toName,
                    CustomText: form.formData.customText
                }]
            };


        form.formData.skuId = skuId;
        hasData = true;
        Vendd.MessageBus.publishAsync($form, new Vendd.Cart.Messages.Add(id, skuId, path, qty, extraAttributes, bundleItems, recipeItems, comboItems, itemInfo, enhancedInfo));
    };

    form.onSuccess = function () {
        form.loading(false);

        $error.hide();
        $formWrapper.hide();
        $success.show();

        //Open the widget only for template 1 of Cart Widget
        if ($('.x-cart-widget').data('template') === 1) {
            Vendd.MessageBus.publishAsync($wrapper, new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.CartWidget, false));
        }
    };

    form.onFailure = function () {
        form.loading(false);
        $error.show();
    };

    form.checkConsents = function () {
        var data = [];

        var checkboxes = $('.form-row.consent.checkbox', form);
        $.each(checkboxes, function (e, el) {
            var chkbx = $('.checkbox-wrapper input', el);
            data.push({ type: chkbx.attr('id'), source: 'Gift Card', approved: chkbx.prop("checked") });
        });

        if (data.length > 0) {
            window.ConsentsManager.insertConsents(data);
        } else {
            form.submit();
        }
    }

    form.loading = function (option) {
        if (option)
            $form.addClass('x-loading');
        else
            $form.removeClass('x-loading');
    }


    valOpts = {
        fromName: {
            required: 'fromName-required'
        },
        toName: {
            required: 'toName-required'
        },
        email: {
            required: 'email-required',
            isEmail: 'email-invalid',
            match: {
                validator: 'emailconfirm-invalid',
                matchField: 'emailconfirm'
            }
        },
        emailconfirm: {
            required: 'emailconfirm-required',
            match: {
                validator: 'emailconfirm-invalid',
                matchField: 'email'
            }
        }
    };

    //add consent validations
    $.each($('div.consent.checkbox[data-required]'), function (e, el) {
        var consentType = $('input', el).attr('name');
        valOpts[consentType] = {
            checkboxRequired: consentType + '-required'
        };
    });


    $form.validationEngine(valOpts);
    rf = $form.data('validationEngine');

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, form, function (envelope) {
        form.loading(false);
    });

    /*Vendd.MessageBus.subscribe(Vendd.Cart.Messages.AddGiftCartEmailAddressSuccess, form, function () {
        form.onSuccess();
    });
    */

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Warning, form, form.onFailure);
    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Failed, form, form.onFailure);
    Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertConsents, form, form.submit);
});


